import { render, staticRenderFns } from "./ProfileUser.vue?vue&type=template&id=b805f7ac&"
import script from "./ProfileUser.vue?vue&type=script&lang=ts&"
export * from "./ProfileUser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports